export const BACKEND_URL = "https://dibportal.bot.go.tz:3023/";
// export const BACKEND_URL = "http://localhost:3023/";
